import PublicSiteApi from '@app/api/public/PublicSiteApi';
import { useQuery } from 'react-query';

const useGetThemeByProjectId = () => {
    return useQuery('getThemeByProjectId', PublicSiteApi.getThemeByProjectId);
};

export default useGetThemeByProjectId;
